import cloneDeep from 'lodash.clonedeep'
import isEqual from 'lodash.isequal'

import { ComponentNotFoundError, FormItemNotFoundError, LayoutNotFoundError } from '../libs/ComponentNotFoundError'

import stdValidations from '../validations/stdValidations'

import getComponent from '../utils/getComponent'

export default {
  name: 'FormMemberBase',

  inject: [
    'components',
    'formItems',
    'layouts',
    'validationMessages',
    'validationRules',
    'handleFormMemberCreated',
    'handleFormMemberDestroyed',
  ],

  emits: ['input'],

  props: {
    value: [String, Number, Boolean, Array, Object],
  },

  data() {
    return {
      isValid: true,
      updatedValidationMessage: '',
    }
  },

  computed: {
    validationMessage() {
      return !this.isValid ? this.updatedValidationMessage : ''
    },
  },

  watch: {
    value: {
      deep: true,
      handler(value) {
        if (isEqual(value, this.model)) {
          return
        }

        this.model = cloneDeep(value)
      },
    },

    model: {
      deep: true,
      async handler(model) {
        if (isEqual(model, this.value)) {
          return
        }
        this.$emit('input', cloneDeep(model))

        try {
          await this.validate()
        } catch (err) {
          if (err instanceof Error) {
            throw err
          }
        }
      },
    },
  },

  created() {
    this.handleFormMemberCreated(this)
  },

  unmounted() {
    this.handleFormMemberDestroyed(this)
  },

  methods: {
    async validate() {
      const {
        required, requiredMessage, type, validation,
      } = this.config
      const validations = stdValidations({
        required,
        requiredMessage,
        type,
        validation,
        customMessages: this.validationMessages,
        customRules: this.validationRules,
      })

      if (validations.length === 0) {
        return
      }

      try {
        const validationPromises = validations.map(validate => validate(this.model))
        const result = await Promise.all(validationPromises)
        const [{ validatedValue }] = result

        // 验证的 value 并非当前 value，放弃该次验证结果
        if (this.isValid && !isEqual(validatedValue, this.value)) {
          return
        }

        this.isValid = true
      } catch ({ validatedValue, validationMessage }) {
        // 验证的 value 并非当前 value，放弃该次验证结果
        if (this.isValid && !isEqual(validatedValue, this.value)) {
          return
        }

        this.isValid = false

        if (validationMessage) {
          this.updatedValidationMessage = validationMessage
        }

        throw validationMessage
      }
    },

    getInput(input) {
      return getComponent(input.is, this.components, ComponentNotFoundError)
    },

    getFormItem(formItem) {
      return getComponent(formItem.is, this.formItems, FormItemNotFoundError, 'FormItem')
    },

    getLayout(layout) {
      return getComponent(layout.is, this.layouts, LayoutNotFoundError, 'Layout')
    },
  },
}
